import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import BackgroundImage from 'gatsby-background-image-es5';

import { animation, colors, media, mediaValues } from '../../styles/constants';

const Circle = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -4rem;

  && .background {
    width: 220vw;
    height: 220vw;

    &:before,
    &:after {
      background-size: 50%;
      background-position: 50% 50%;
    }
  }

  @media (min-width: ${media.phone}) {
    top: -6rem;
  }

  @media (min-width: ${media.workdetail1stBreakpoint}) {
    top: calc(-2rem - 1%);

    && .background {
      width: 200vw;
      height: 200vw;

      &:before,
      &:after {
        background-size: 70%;
      }
    }
  }

  @media (min-width: 530px) {
    top: -12rem;

    && .background {
      width: 190vw;
      height: 190vw;
    }
  }

  @media (min-width: ${media.workdetail2ndBreakpoint}) {
    top: -18rem;

    && .background {
      width: 180vw;
      height: 180vw;
    }
  }

  @media (min-width: ${media.tabletPortrait}) {
    top: -20rem;

    && .background {
      width: 170vw;
      height: 170vw;
    }
  }

  @media (min-width: 900px) {
    top: -25rem;

    && .background {
      width: 160vw;
      height: 160vw;
    }
  }

  @media (min-width: ${media.tabletLandscape}) {
    left: auto;
    top: auto;
    transform: none;

    && .background {
      &:before,
      &:after {
        background-position: 100% 60%;
        background-size: 85%;
      }
    }
  }
`;

class AboutCircle extends Component {
  static propTypes = {
    color: PropTypes.string,
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isInView: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  static defaultProps = {
    color: colors.cyan
  };

  render() {
    const { image, color, isInView, width, height, top, left } = this.props;

    let windowWidth = 1024;
    if (typeof window !== 'undefined' || typeof document !== 'undefined') {
      windowWidth = window.innerWidth || document.documentElement.clientWidth;
    }

    let extraStyles =
      windowWidth >= mediaValues.tabletLandscape
        ? {
            top,
            left,
            width,
            height
          }
        : {};

    return (
      <Circle>
        <BackgroundImage
          critical
          section="div"
          className="background"
          fluid={image}
          backgroundColor={color}
          style={{
            willChange: 'transform, opacity',
            borderRadius: '100%',
            backgroundRepeat: 'no-repeat',
            transitionProperty: 'transform, opacity',
            transitionDuration: `${animation.introCircle}ms`,
            transitionTimingFunction: 'ease-in-out',
            transformOrigin: 'center left',
            transform: `rotate(${(isInView ? 0 : 1) * -180}deg)`,
            opacity: top && left && width && height && isInView >= 0 ? 1 : 0,
            ...extraStyles
          }}
        />
      </Circle>
    );
  }
}

export default AboutCircle;
